module.exports = __webpack_public_path__ + "img/open-source.2eff2bad.png";